import React, { Component } from 'react';
import CanvasDraw from "react-canvas-draw";
import {
    Button, FormGroup, ComposedModal, ModalHeader, ModalBody, ModalFooter, TextArea, Loading
} from 'carbon-components-react';
import { fileUpload, api } from '../../helpers/api/api';
import { v4 as uuid } from 'uuid';
import { ComboBox } from '../../helpers/ComboBox'
import { Erase16 } from '@carbon/icons-react';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { entitiesLabels } from '../../helpers/Constants';
import ImgSignature from './ImgSignature'
/**
 * Modal inserimento firma dei Partecipanti
 *      key: string
 *      title: string
 *      editModel: obj
 *      isOpenModal: bool
 *      toggleModal: fn
 *      save: fn
 *      idTraining: guid
 */
export default class ModalSignatureParticipant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            model: {
                ...this.props.editModel
            },
            appKnowledgeAssessment: ['Pass', 'Fail', 'Absent'],
            StoragePath: 'training',
            isSubmitted: false,
            showCanvas: this.props.editModel && !this.props.editModel.signatureAttachment /*devOps 640 */ && (this.props.editModel.knowledgeAssessment && this.isAbsent(this.props.editModel.knowledgeAssessment) ? false : true)
        }
    }

        componentDidMount() {
    }

    isAbsent = (string) => string?.toLowerCase() === "absent";


    updateState = (inputName, inputValue, objName) => {
        let statusCopy = Object.assign({}, this.state.model);
        if (objName && objName != 'model') statusCopy[objName][inputName] = inputValue;
        else statusCopy[inputName] = inputValue;

        //devOps 640
        if(inputName === "knowledgeAssessment") {
            if (this.isAbsent(inputValue) || !inputValue ) {
                this.state.showCanvas = false
                statusCopy.signatureAttachment = null
            } else if (!this.state.model?.signatureAttachment && !this.props.editModel.signatureAttachment) this.state.showCanvas = true
            else if (this.props.editModel.signatureAttachment) statusCopy.signatureAttachment = this.props.editModel.signatureAttachment
        }
        //
        this.setState({ model: statusCopy,  });
    }

    clearImage = () => {
        if (this.props.editModel && this.props.editModel.signatureAttachment) {
            //this.setState({ showCanvas: true });
            //devOps 640
            this.setState({
                showCanvas: this.isAbsent(this.state.model.knowledgeAssessment) ? false : true
            });
            
        }
        if (this.saveableCanvas) this.saveableCanvas.clear();
    }

    showLoading() {
        return (this.state.isSubmitted && <Loading active={true} withOverlay={true} description={"Saving..."} />);
    }

    save = async () => {
        this.setState({ 'isSubmitted': true });
        let dati = this.state.model;

        try {
            let fileIdentifier = await this.saveImage();

            if (fileIdentifier != null) dati.signatureAttachment = fileIdentifier
            if (!dati.signatureAttachment && !this.isAbsent(dati.knowledgeAssessment) && this.props.editModel.signatureAttachment) dati.signatureAttachment = this.props.editModel.signatureAttachment
            if(!dati.knowledgeAssessment && this.props.editModel.knowledgeAssessment) dati.knowledgeAssessment = this.props.editModel.knowledgeAssessment;
            await api.put('/training/', dati, `${this.props.idTraining}/signature/${this.props.editModel.id}`);

            this.props.save(dati);
            showNotification.success(`${entitiesLabels.SUCCESS}`,"Participant saved successfully");
        } catch (error) {
            showNotification.error(`${entitiesLabels.ERROR}`,"Error saving Participant: " + error.message);
        } finally {
            this.setState({ 'isSubmitted': false });
        }
    }

    saveImage = async () => {
        //RITM1014911 - Added try/catch for throwing the exception
        try{
            if (this.saveableCanvas) {
                const canvas = this.saveableCanvas.canvasContainer.children[1];
                if (canvas == null || isCanvasBlank(canvas)) {
                    //showNotification.warning("Warning: required fields are missing  ");
                    return null;
                }
                this.setState({ 'isSubmitted': true });
                const csvURL = canvas.toDataURL();
                const base64 = csvURL.split(',')[1];
                const fileAsBlob = base64toBlob(base64, 'image/png');
    
                const fileName = `sg${uuid()}.png`;
    
                const blobAsFile = new File([fileAsBlob], fileName, {
                    type: 'image/png',
                });
    
                const fileIdentifier = `${this.state.StoragePath}_${new Date().getTime()}_${fileName}`;
    
                const formData = new FormData();
                formData.append('File', blobAsFile);
                formData.append('Container', 'saipem');
                formData.append('StoragePath', this.state.StoragePath);
                formData.append('FileIdentifier', fileIdentifier);
    
                await fileUpload.post(formData);
                return fileIdentifier;
            }
        }
        catch (error) {
            throw error;
        }
        //End
        return null;
    }

    render() {
        if (this.props.editModel == null) return null;

        const { title, isOpenModal } = this.props;

        const showCanvas = this.state.showCanvas /*devOps 640*/ && this.state.model.knowledgeAssessment;
        const thereIsImage = this.state.model && this.state.model.signatureAttachment
        const modalHeader = {
            title: title || 'Signature',
            iconDescription: 'Close',
            buttonOnClick: () => this.props.toggleModal(false)
        };
        return (
            <ComposedModal
                className="light-modal"
                open={isOpenModal}
                danger="false"
                onClose={() => { return false; }}
            >
                <ModalHeader className="margin-modal" {...modalHeader} ></ModalHeader>
                <ModalBody className="margin-modal">
                    {this.showLoading()}
                    <div className="bx--grid--full-width">
                        <div className="bx--row row-content">
                            <div className="bx--col-md-12 bx--col-lg-12">
                                <FormGroup legendText="Knowledge Assessment">
                                    <ComboBox
                                        id="knowledgeAssessment"
                                        key={`ka${this.state.model.knowledgeAssessment}`}
                                        placeholder="Select"
                                        name="knowledgeAssessment"
                                        alt="model"
                                        onChange={this.updateState}
                                        itemToString={item => (item ? item : '')}
                                        initialSelectedItem={this.state.model.knowledgeAssessment}
                                        items={this.state.appKnowledgeAssessment}
                                    />
                                </FormGroup>
                            </div>
                            <div className="bx--col-md-12 bx--col-lg-12">
                                <FormGroup legendText="Note">
                                    <TextArea
                                        id="note"
                                        maxLength={5000}
                                        placeholder="Input note (max 5000 characters)"
                                        value={this.state.model.note || ''}
                                        onChange={(el) => this.updateState('note', el.target.value, 'model')}
                                        hideLabel={true}
                                        labelText=""
                                        light
                                        rows={6}
                                        cols={100}
                                    />
                                </FormGroup>
                            </div>

                        </div>
                        <div className="bx--row row-content canvas-sign">
                            {(showCanvas || thereIsImage)  &&
                                <div className="bx--col-lg-12 bx--col-md-12">
                                    <h3>{`${this.props.editModel.name} ${this.props.editModel.surname}`}</h3>
                                </div>
                            }
                            {showCanvas ?
                                <div className="bx--col-lg-12 bx--col-md-12">
                                    <CanvasDraw
                                        ref={canvasDraw => (this.saveableCanvas = canvasDraw)}
                                        onChange={null}
                                        loadTimeOffset={0}
                                        lazyRadius={2}
                                        brushRadius={2}
                                        brushColor="#444"
                                        catenaryColor="#0a0302"
                                        gridColor="rgba(150,150,150,0.17)"
                                        hideGrid={false}
                                        canvasWidth={473}
                                        canvasHeight={200}
                                        disabled={false}
                                        imgSrc=""
                                        saveData={null}
                                        immediateLoading={false}
                                        hideInterface={true}
                                    />
                                    <Button kind='danger' size='field' renderIcon={Erase16} onClick={() => this.clearImage()}>Clear</Button>
                                </div>
                                : thereIsImage ?
                                <div className="bx--col-lg-12 bx--col-md-12">
                                    <div>
                                        <ImgSignature idTraining={this.props.idTraining} fileIdentifier={this.props.editModel.signatureAttachment} />
                                    </div>
                                    <Button kind='danger' size='field' renderIcon={Erase16} onClick={() => this.clearImage()}>Clear</Button>
                                </div>
                                : null
                            }
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button kind="secondary" onClick={() => this.props.toggleModal(false)}>Cancel</Button>
                    <Button kind='primary' onClick={() => this.save()} >Save</Button>
                </ModalFooter>
            </ComposedModal>
        );
    }
}


function base64toBlob(base64Data, contentType) {
    contentType = contentType || '';
    const sliceSize = 1024;
    const byteCharacters = window.atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        const begin = sliceIndex * sliceSize;
        const end = Math.min(begin + sliceSize, bytesLength);

        const bytes = new Array(end - begin);
        for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
}

function isCanvasBlank(canvas) {
    return !canvas.getContext('2d')
        .getImageData(0, 0, canvas.width, canvas.height).data
        .some(channel => channel !== 0);
}